import React from 'react'
import { Input, InputProps } from 'reactstrap'
import { InputArea } from './style'
import { InfosInputs } from 'styles/global'
import { Tooltip } from '@mui/material'

interface InputCustomProps extends InputProps {
  message?: string
  infoMessage?: string
}

function InputCustom({ message, infoMessage, ...rest }: InputCustomProps) {
  return (
    <InputArea type={rest.type || ''}>
      <Input {...rest} max={rest.type === 'date' ? '2999-12-31' : rest.max} />
      {infoMessage && <InfosInputs>{infoMessage}</InfosInputs>}
      {rest.invalid && message && (
        <Tooltip title={message} placement="bottom-start">
          <span className="error-message">{message}</span>
        </Tooltip>
      )}
    </InputArea>
  )
}

export default InputCustom
